import React, { FC } from 'react'

interface Props {
  size?: number
}

export const CreateIconSelected: FC<Props> = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
    <rect x="1" y="1" width="18" height="18" rx="9" fill="white" />
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="9"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M15.3334 7L8.00008 14.3333L4.66675 11"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
